import { create } from 'zustand';

interface CheckinState {
  step: number;
  setStep: (step: number) => void;
}

const useCheckinStore = create<CheckinState>((set) => ({
  step: 0,
  setStep: (step: number) => {
    set((state) => ({
      ...state,
      step,
    }));
  },
}));

export default useCheckinStore;

// export const useSearchStore = createSelectors(_useSearchStore);
